import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './ProGate.css';

const IcCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const IcSparkle = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2L12 3z"/>
  </svg>
);

const IcArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

export default function ProGate({ feature = 'this feature', requiresAuth = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const featureKeys = ['renovation', 'neighbourhood', 'alerts', 'inbox', 'reports'];

  return (
    <div className="progate">
      <div className="progate__background" />

      <div className="progate__card">
        <div className="progate__badge">
          <IcSparkle />
          <span>{t('progate.badge')}</span>
        </div>

        <h1 className="progate__title">
          {requiresAuth ? t('progate.signInRequired') : t('progate.proRequired')}
        </h1>

        <p className="progate__sub">
          {requiresAuth
            ? t('progate.signInMsg').replace('{feature}', feature)
            : t('progate.proMsg').replace('{feature}', feature)
          }
        </p>

        <ul className="progate__features">
          {featureKeys.map((key) => (
            <li key={key} className="progate__feature">
              <span className="progate__feature-check"><IcCheck /></span>
              <span>{t(`progate.features.${key}`)}</span>
            </li>
          ))}
        </ul>

        <div className="progate__btns">
          {requiresAuth ? (
            <>
              <button
                className="progate__btn progate__btn--primary"
                onClick={() => navigate('/login', { state: { from: location.pathname } })}
              >
                {t('progate.signIn')}
                <IcArrow />
              </button>
              <button
                className="progate__btn progate__btn--ghost"
                onClick={() => navigate('/register', { state: { from: location.pathname } })}
              >
                {t('progate.createAccount')}
              </button>
            </>
          ) : (
            <button
              className="progate__btn progate__btn--primary"
              onClick={() => navigate('/checkout')}
            >
              {t('progate.viewPlans')}
              <IcArrow />
            </button>
          )}
        </div>

        <p className="progate__note">
          {requiresAuth ? t('progate.noteAuth') : t('progate.notePro')}
        </p>
      </div>
    </div>
  );
}
